import React, { useState } from 'react';
import styles from './InteractiveImage.module.css';

interface Point {
  id: string;
  x: number;
  y: number;
  label: string;
  description: string;
}

interface InteractiveImageProps {
  imageUrl: string;
  points: Point[];
  width?: string;
  height?: string;
}

const InteractiveImage: React.FC<InteractiveImageProps> = ({
  imageUrl,
  points,
  width,
  height,
}) => {
  const [activePoint, setActivePoint] = useState<string | null>(null);

  const calculateArrowAngle = (x1: number, y1: number, x2: number, y2: number) => {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return Math.atan2(dy, dx) * (180 / Math.PI);
  };

  return (
    <div className={styles.container} style={{ width, height }}>
      <img src={imageUrl} alt="Interactive diagram" className={styles.image} />
      {points.map((point) => (
        <React.Fragment key={point.id}>
          <div
            className={styles.pointMarker}
            style={{ left: `${point.x}%`, top: `${point.y}%` }}
            onClick={() => setActivePoint(activePoint === point.id ? null : point.id)}
          />
          <div
            className={styles.arrow}
            style={{
              left: `${point.x}%`,
              top: `${point.y}%`,
              transform: `rotate(${calculateArrowAngle(point.x, point.y, point.x + 5, point.y)}deg)`
            }}
          />
          <div
            className={styles.tooltip}
            style={{
              left: `${point.x}%`,
              top: `${point.y}%`,
              opacity: activePoint === point.id ? 1 : 0,
              visibility: activePoint === point.id ? 'visible' : 'hidden'
            }}
          >
            <h3 className={styles.tooltipTitle}>{point.label}</h3>
            <p className={styles.tooltipDescription}>{point.description}</p>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default InteractiveImage; 